import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { Button } from './ui/button';
import { LANGS } from '@/i18n';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const next = i18n.resolvedLanguage === 'ar' ? 'en' : 'ar';
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={() => i18n.changeLanguage(next as (typeof LANGS)[number])}
      aria-label={t('nav.language')}
    >
      <Languages className="h-4 w-4" />
      <span className="text-xs font-semibold uppercase">
        {i18n.resolvedLanguage === 'ar' ? 'EN' : 'ع'}
      </span>
    </Button>
  );
}
